import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ExternalApplicationOPEEnum} from "./ExternalApplicationOPEEnum";
import {ApiConfig} from "../../models/external-application/ApiConfig";

class ExternalApplicationDTO {
  public partitionId!: number;
  public id!: number;
  public email!: string;
  public description!: string;
  public language?: string;
  public enabled!: boolean;
  public apiConfigMap!: Record<string, ApiConfig>;
  linkedPartitions?: number[];
}

class O {
  externalApplications!: ExternalApplicationDTO[];
}

/**
 * O Inner Class
 */
class I {
  partitionId!: number;
}


/**
 * GetExternalApplicationCB class
 */
export class GetExternalApplicationCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ExternalApplicationOPEEnum.GetExternalApplication);
    this.i = new I();
    this.o = new O();
  }

}
